import { Component, input, computed } from '@angular/core';

const DEFAULT_WIDTHS = [256, 512, 1024] as const;
const MODERN_FORMATS = ['avif', 'webp'] as const;

@Component({
	selector: 'responsive-image',
	templateUrl: './responsive-image.component.html',
	styleUrls: ['./responsive-image.component.scss'],
	imports: [],
})
export class ResponsiveImageComponent {
	imageName = input.required<string>();
	imageAlt = input<string>('');
	imageWidth = input<number>();
	imageHeight = input<number>();
	imageBoundary = input<number>();
	itemProp = input<string>();
	isLazyLoaded = input<boolean>(true);
	sizes = input<string | null>(null);

	readonly modernFormats = MODERN_FORMATS;
	private readonly widths = DEFAULT_WIDTHS;
	private readonly basePath = 'assets/img/';

	readonly sizesAttr = computed(() => {
		const sz = this.sizes();
		if (sz) return sz;
		const w = this.imageWidth();
		if (w) return `${w}px`;
		const b = this.imageBoundary();
		if (b) return `${b}px`;
		return "(max-width: 580px) 256px, (max-width: 768px) 512px, 100vw";
	});

	private readonly enabledWidths = computed(() => {
		const b = this.imageBoundary();
		const max = b ?? this.widths[this.widths.length - 1];
		const allowed = this.widths.filter((w) => w <= max);
		return allowed.length ? allowed : [this.widths[0]];
	});

	private readonly fallbackWidth = computed(() => {
		const enabled = this.enabledWidths();
		return enabled[enabled.length - 1];
	});

	readonly fallbackSrc = computed(() => {
		const name = this.imageName();
		if (!name) return 'data:,';
		return `${this.basePath}${name}-${this.fallbackWidth()}.jpg`;
	});

	buildSrcset(ext: string): string {
		const name = this.imageName();
		if (!name) return '';
		return this.enabledWidths()
			.map((w) => `${this.basePath}${name}-${w}.${ext} ${w}w`)
			.join(', ');
	}
}
